import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type { CopyProcessRequestBody, CopyProcessResponseBody } from './types';

export const useCopyProcess: MutationFunction<
  CopyProcessResponseBody,
  CopyProcessRequestBody
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation({
    mutationFn: (requestData) => {
      return request<CopyProcessResponseBody>(
        `/processes/${requestData.processId}/copy`,
        {
          query,
          init: {
            method: 'POST',
            body: requestData,
          },
        },
      );
    },
    ...queryOptions,
    mutationKey: ['copyProcess'],
  });
};
